import { options } from "../../hooks/use-search-filters-formatting/formatter-options";
export function extractMappingsFromMakesFacet(makes) {
    if (makes.length === 0 && Object.keys(options.mappings.makes).length > 0) {
        // This prevents a transient empty object being used by the formatters
        return options.mappings;
    }
    const output = {
        makes: {},
        models: {},
        variants: {}
    };
    makes.forEach((make)=>{
        output.makes[make.name.toUpperCase()] = make.name;
        make.models.forEach((model)=>{
            output.models[model.name.toUpperCase()] = model.name;
            model.variants.forEach((variant)=>{
                output.variants[variant.name.toUpperCase()] = variant.name;
            });
        });
    });
    return output;
}
